import { returnFormattedDate } from "@/lib/globalFormatterHelper";
import { useTheme } from "next-themes";

// LQC-2259 - reads theme itself so the colDefs memo doesn't need a theme dep.
// Rebuilding colDefs re-applies every colDef's hide/width over the saved column state.
const CreationEffectiveDateCellRenderer = (params: any) => {
  const { theme } = useTheme();

  if (!params.data) return "";

  const editableClass =
    theme == "light"
      ? "inputCellOtherLight roundedInputCell"
      : "inputCellOtherDark roundedInputCell";

  return (
    <div
      data-testid="CreationEffectiveDateCellContainer"
      id="CreationEffectiveDateCellContainer"
      className={`ag-roundedInputStyle ${editableClass}`}
    >
      {params.value ? returnFormattedDate(params.value) : ""}
    </div>
  );
};

export default CreationEffectiveDateCellRenderer;
